export const actions = {
    GET_ISSUES_WITH_ORDERS_ARTICLES: 'GET_ISSUES_WITH_ORDERS_ARTICLES',
    GET_ISSUES_WITH_ORDERS_ARTICLES_SUCCESS: 'GET_ISSUES_WITH_ORDERS_ARTICLES_SUCCESS',
    GET_ISSUES_WITH_ORDERS_ARTICLES_FAILED: 'GET_ISSUES_WITH_ORDERS_ARTICLES_FAILED',

    GET_ACTIVE_ORDERS_ARTICLES: 'GET_ACTIVE_ORDERS_ARTICLES',
    GET_ACTIVE_ORDERS_ARTICLES_SUCCESS: 'GET_ACTIVE_ORDERS_ARTICLES_SUCCESS',
    GET_ACTIVE_ORDERS_ARTICLES_FAILED: 'GET_ACTIVE_ORDERS_ARTICLES_FAILED',

    GET_PAST_ORDERS_IWAO_ARTICLES: 'GET_PAST_ORDERS_IWAO_ARTICLES',
    GET_PAST_ORDERS_IWAO_ARTICLES_SUCCESS: 'GET_PAST_ORDERS_IWAO_ARTICLES_SUCCESS',
    GET_PAST_ORDERS_IWAO_ARTICLES_FAILED: 'GET_PAST_ORDERS_IWAO_ARTICLES_FAILED',
    GET_PAST_ORDERS_IWDP_ARTICLES: 'GET_PAST_ORDERS_IWDP_ARTICLES',
    GET_PAST_ORDERS_IWDP_ARTICLES_SUCCESS: 'GET_PAST_ORDERS_IWDP_ARTICLES_SUCCESS',
    GET_PAST_ORDERS_IWDP_ARTICLES_FAILED: 'GET_PAST_ORDERS_IWDP_ARTICLES_FAILED',

    VOTE_THE_ARTICLE: 'VOTE_THE_ARTICLE',
    VOTE_THE_ARTICLE_SUCCESS: 'VOTE_THE_ARTICLE_SUCCESS',
    VOTE_THE_ARTICLE_FAILED: 'VOTE_THE_ARTICLE_FAILED',
    GET_VOTES_BY_ARTICLE: 'GET_VOTES_BY_ARTICLE',
    GET_VOTES_BY_ARTICLE_SUCCESS: 'GET_VOTES_BY_ARTICLE_SUCCESS',
    GET_VOTES_BY_ARTICLE_FAILED: 'GET_VOTES_BY_ARTICLE_FAILED',

    GET_ITEMS_ISSUES_LIST: 'GET_ITEMS_ISSUES_LIST',
    GET_ITEMS_ISSUES_LIST_SUCCESS: 'GET_ITEMS_ISSUES_LIST_SUCCESS',
    GET_ITEMS_ISSUES_LIST_FAILED: 'GET_ITEMS_ISSUES_LIST_FAILED',

    GET_DELIVERY_ISSUES_LIST: 'GET_DELIVERY_ISSUES_LIST',
    GET_DELIVERY_ISSUES_LIST_SUCCESS: 'GET_DELIVERY_ISSUES_LIST_SUCCESS',
    GET_DELIVERY_ISSUES_LIST_FAILED: 'GET_DELIVERY_ISSUES_LIST_FAILED',
}

export const getIssuesWithOrdersArticles = () => ({
    type: actions.GET_ISSUES_WITH_ORDERS_ARTICLES,
})

export const getIssuesWithOrdersArticlesSuccess = data => ({
    type: actions.GET_ISSUES_WITH_ORDERS_ARTICLES_SUCCESS,
    payload: data,
})

export const getIssuesWithOrdersArticlesFailed = () => ({
    type: actions.GET_ISSUES_WITH_ORDERS_ARTICLES_FAILED,
})

export const getActiveOrdersArticles = () => ({
    type: actions.GET_ACTIVE_ORDERS_ARTICLES,
})

export const getActiveOrdersArticlesSuccess = response => ({
    type: actions.GET_ACTIVE_ORDERS_ARTICLES_SUCCESS,
    payload: response,
})

export const getActiveOrdersArticlesFailed = () => ({
    type: actions.GET_ACTIVE_ORDERS_ARTICLES_FAILED,
})

export const getPastOrdersIWAOArticles = () => ({
    type: actions.GET_PAST_ORDERS_IWAO_ARTICLES,
})

export const getPastOrdersIWAOArticlesSuccess = response => ({
    type: actions.GET_PAST_ORDERS_IWAO_ARTICLES_SUCCESS,
    payload: response,
})

export const getPastOrdersIWAOArticlesFailed = () => ({
    type: actions.GET_PAST_ORDERS_IWAO_ARTICLES_FAILED,
})

export const getPastOrdersIWDPArticles = () => ({
    type: actions.GET_PAST_ORDERS_IWDP_ARTICLES,
})

export const getPastOrdersIWDPArticlesSuccess = response => ({
    type: actions.GET_PAST_ORDERS_IWDP_ARTICLES_SUCCESS,
    payload: response,
})

export const getPastOrdersIWDPArticlesFailed = () => ({
    type: actions.GET_PAST_ORDERS_IWDP_ARTICLES_FAILED,
})

export const VoteTheArticle = data => ({
    type: actions.VOTE_THE_ARTICLE,
    payload: data,
})

export const VoteTheArticleSuccess = response => ({
    type: actions.VOTE_THE_ARTICLE_SUCCESS,
    payload: response,
})

export const VoteTheArticleFailed = () => ({
    type: actions.VOTE_THE_ARTICLE_FAILED,
})

export const getVotesByArticle = data => ({
    type: actions.GET_VOTES_BY_ARTICLE,
    payload: data,
})

export const getVotesByArticleSuccess = data => ({
    type: actions.GET_VOTES_BY_ARTICLE_SUCCESS,
    payload: data,
})

export const getVotesByArticleFailed = () => ({
    type: actions.GET_VOTES_BY_ARTICLE_FAILED,
})

export const getItemsIssuesList = () => ({
    type: actions.GET_ITEMS_ISSUES_LIST,
})

export const getItemsIssuesListSuccess = data => ({
    type: actions.GET_ITEMS_ISSUES_LIST_SUCCESS,
    payload: data,
})

export const getItemsIssuesListFailed = () => ({
    type: actions.GET_ITEMS_ISSUES_LIST_FAILED,
})

export const getDeliveryIssuesList = () => ({
    type: actions.GET_DELIVERY_ISSUES_LIST,
})

export const getDeliveryIssuesListSuccess = data => ({
    type: actions.GET_DELIVERY_ISSUES_LIST_SUCCESS,
    payload: data,
})

export const getDeliveryIssuesListFailed = () => ({
    type: actions.GET_DELIVERY_ISSUES_LIST_FAILED,
})
